import React from "react";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { useStateContext } from "../global-context/useGlobalContext";
import stars from "../img/starts.mp4";

const BackgroundVideo = () => {
  const isCpu = useMediaQuery({ minWidth: 600 });
  const isPortrait = useMediaQuery({ minWidth: 1600 });
  const { setLoading } = useStateContext();
  return (
    <Video>
      <video
        src={stars}
        playsInline
        autoPlay
        loop
        muted
        onLoadedData={() => setLoading(false)}
        height={isCpu ? (isPortrait ? "1200vh" : "900vh") : "900vh"}
        alt="Mountain Top video"
      />
    </Video>
  );
};

export default BackgroundVideo;

const Video = styled.div`
  position: fixed;
  z-index: -5;
  filter: hue-rotate(22deg) brightness(0.3);
  object-fit: cover;
  @media (max-width: 950px) {
    right: -50%;
  }
`;
